import React, { InputHTMLAttributes } from 'react';

interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
    value: string;
    type?: string;
    name: string;
    label?: string | React.ReactNode;
    placeholder?: string;
    error?: boolean;
    helperText?: string;
}

function InputField({
    value,
    type = 'text',
    name,
    label = '',
    placeholder = '',
    error = false,
    helperText = '',
    ...rest
}: InputFieldProps) {
    return (
        <div className="space-y-1">
            {label && (
                <label className="pl-4 text-brand font-semibold" htmlFor={name}>
                    {label}
                </label>
            )}
            <input
                id={name}
                value={value}
                type={type}
                name={name}
                placeholder={placeholder}
                className={`rounded-full border border-gray-500 py-2 px-4 shadow-sm focus:outline-none focus:ring-brand focus:ring-2 w-full whitespace-nowrap overflow-hidden text-ellipsis disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-400 disabled:shadow-none ${
                    error ? 'border-red-500' : ''
                }`}
                {...rest}
            />
            {helperText && (
                <div className={`pl-4 text-xs text-left ${error ? 'text-danger' : 'text-secondary'}`}>{helperText}</div>
            )}
        </div>
    );
}

export default InputField;
